import type { FetchOrganizationByIdArgs } from '../../api/types/organizations.types';

import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export default function useOrganizationById(
  { id }: Partial<FetchOrganizationByIdArgs>,
  enabled = true,
) {
  const { queryFn, queryKey } = queryKeys.organizations.fetchOrganizationById({
    id: id ?? '',
  });
  return useQuery({
    enabled: !!id && enabled,
    queryFn,
    queryKey,
  });
}
